// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"532c163a","673":"9ef7c7ea","767":"6e860842","904":"22f92fc6"}[chunkId] + ".chunk.js";
};